import React, { createContext, useContext, useState, useEffect } from 'react';
import { it, fr, de, enUS } from 'date-fns/locale';

const dateLocales = { it, fr, de, en: enUS };

const translations = {
  it: {
    // Header
    systemName: 'CoWork Desk',
    systemSubtitle: 'Sistema Prenotazioni',
    desks: 'Scrivanie',
    meetingRoom: 'Sala Riunioni',
    parking: 'Parcheggi',
    logout: 'Esci',
    admin: 'Admin',

    // Login
    welcome: 'Bentornato!',
    loginSubtitle: 'Accedi per prenotare la tua scrivania',
    loginDescription: 'Prenota la tua scrivania in modo semplice e veloce',
    email: 'Email',
    password: 'Password',
    login: 'Accedi',
    loggingIn: 'Accesso in corso...',
    contactAdmin: "Contatta l'amministratore per ottenere le credenziali",
    emailPlaceholder: 'nome@esempio.com',
    passwordPlaceholder: 'La tua password',

    // Common
    book: 'Prenota',
    confirm: 'Conferma',
    cancel: 'Annulla',
    delete: 'Elimina',
    save: 'Salva',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',

    // Desks
    selectPeriod: 'Seleziona il periodo',
    deskMap: 'Mappa delle scrivanie',
    myBookings: 'Le mie prenotazioni',
    available: 'Disponibile',
    occupied: 'Occupata',
    yourBooking: 'La tua',
    selected: 'Selezionata',
    notActive: 'Non attiva',
    entrance: 'INGRESSO',
    windows: 'FINESTRE',
    corridor: 'Corridoio',
    deskSelected: 'Scrivania {desk} selezionata',
    confirmBooking: 'Conferma Prenotazione',
    noBookings: 'Non hai ancora prenotazioni',
    goToBook: 'Vai alla sezione "Prenota" per prenotare una scrivania',
    from: 'Dal',
    to: 'al',
    days: 'giorni',
    day: 'giorno',
    selectedPeriodLabel: 'Periodo selezionato:',
    clickStartEnd: 'Clicca su una data di inizio, poi sulla data di fine',
    selectPeriodAndDesk: 'Seleziona un periodo e una scrivania',
    deskBookedSuccess: 'Scrivania {desk} prenotata con successo!',
    bookingCancelled: 'Prenotazione cancellata',
    yourBookings: 'Le tue prenotazioni',

    // Meeting Room
    meetingRoomTitle: 'Sala Riunioni',
    meetingRoomSubtitle: 'Prenota la sala riunioni per le tue riunioni',
    calendar: 'Calendario',
    selectDay: 'Seleziona un giorno',
    clickDay: 'Clicca su un giorno per vedere il dettaglio',
    free: 'Libera',
    partial: 'Parziale',
    fullDay: 'Piena',
    bookMeetingRoom: 'Prenota Sala Riunioni',
    meetingTitle: 'Titolo riunione',
    meetingTitlePlaceholder: 'Es. Riunione team marketing',
    startTime: 'Ora inizio',
    endTime: 'Ora fine',
    description: 'Descrizione (opzionale)',
    descriptionPlaceholder: 'Aggiungi dettagli sulla riunione...',
    meetingRoomBooked: 'Sala riunioni prenotata!',
    freeSlot: 'Libero',
    dayLetters: ['L', 'M', 'M', 'G', 'V', 'S', 'D'],
    dayShort: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],

    // Parking
    parkingTitle: 'Parcheggi',
    parkingSubtitle: 'Prenota il tuo posto auto',
    selectDate: 'Seleziona la data',
    parkingMap: 'Mappa Parcheggi',
    morning: 'Mattino',
    afternoon: 'Pomeriggio',
    fullDayParking: 'Giornata',
    selectPeriodParking: 'Seleziona il periodo:',
    parkingBooked: 'Parcheggio {spot} prenotato per {period}!',
    yourParkingBookings: 'Le tue prenotazioni parcheggio',
    noParkingBookings: 'Non hai prenotazioni parcheggio',
    commonArea: 'Area comune',
    parkingFree: 'Libero',
    parkingPartial: 'Parziale',
    parkingOccupied: 'Occupato',
    parkingYours: 'Tuo',
    parkingNotActive: 'Non attivo',
    selectDateFirst: 'Seleziona prima una data',
    periodNotAvailable: 'Questo periodo non è disponibile',
    selectDateAndSpot: 'Seleziona data e parcheggio',
    parkingSpotLabel: 'Parcheggio',
    parkingFullDay: 'Giornata intera',

    // Admin
    manageDesks: 'Gestione Scrivanie',
    manageParking: 'Gestione Parcheggi',
    toggleAvailability: 'Attiva o disattiva le scrivanie disponibili per la prenotazione',
    toggleParkingAvailability: 'Attiva o disattiva i parcheggi disponibili per la prenotazione',
    active: 'Attivo',
    disabled: 'Disattivato',
    overview: 'Panoramica',
    users: 'Utenti',
    bookings: 'Prenotazioni',
    userManagement: 'Gestione Utenti',
    newUser: 'Nuovo Utente',
    createUser: 'Crea Utente',
    createNewUser: 'Crea Nuovo Utente',
    name: 'Nome',
    namePlaceholder: 'Mario Rossi',
    adminEmailPlaceholder: 'mario@esempio.com',
    adminPasswordPlaceholder: 'Password sicura',
    administrator: 'Amministratore',
    user: 'Utente',
    noUsers: 'Nessun utente trovato',
    allBookings: 'Tutte le Prenotazioni',
    noBookingsFound: 'Nessuna prenotazione',
    blockDesk: 'Blocca Scrivania {desk}',
    blockDeskBtn: 'Blocca Scrivania',
    desk: 'Scrivania',
    spot: 'Posto',
    past: 'Passata',
    showPastBookings: 'Mostra prenotazioni passate',
    filterByDesk: 'Filtra per scrivania',
    allDesks: 'Tutte le scrivanie',
    deskBlockedSuccess: 'Scrivania {desk} bloccata per {days} giorni',
    deskActivated: 'Scrivania {desk} attivata',
    deskDeactivated: 'Scrivania {desk} disattivata',
    userCreatedSuccess: 'Utente creato con successo',
    confirmDeleteUser: 'Sei sicuro di voler eliminare questo utente?',
    userDeleted: 'Utente eliminato',
    parkingActivated: 'Parcheggio {spot} attivato',
    parkingDeactivated: 'Parcheggio {spot} disattivato',
    roleAdmin: 'Amministratore',
    roleUser: 'Utente',
    setAsAdmin: 'Imposta come amministratore',
    roleUpdated: 'Ruolo aggiornato',
    cannotChangeOwnRole: 'Non puoi cambiare il tuo ruolo',
    monitor: 'Monitor',
    hasMonitor: 'Monitor',
    withMonitor: 'Con monitor',
    withoutMonitor: 'Senza monitor',
    availableWeekdays: 'Giorni disponibili',
    weekdaysUpdated: 'Giorni disponibili aggiornati per la scrivania {desk}',
    weekdaysMinOne: 'Almeno un giorno deve rimanere disponibile',
    verifyEmailTitle: 'Verifica il tuo indirizzo email',
    verifyEmailDesc: 'Ti abbiamo inviato un\'email a {email}. Conferma il tuo indirizzo per poter prenotare.',
    resendVerification: 'Invia di nuovo l\'email',
    verificationEmailSent: 'Email di verifica inviata! Controlla la tua casella.',
    verifyEmailSuccessTitle: 'Email verificata!',
    verifyEmailSuccessDesc: 'Il tuo indirizzo è confermato. Ora puoi prenotare scrivanie, sala riunioni e parcheggi.',
    verifyEmailErrorTitle: 'Verifica non riuscita',
    verifyEmailInvalid: 'Link di verifica non valido o già utilizzato',
    verifyEmailContinue: 'Vai alla dashboard',
    registerCheckEmail: 'Registrazione completata! Controlla la tua email per confermare l\'indirizzo.',
    confirmationEmailSent: 'Ti abbiamo inviato il riepilogo per email',
    // Registration
    register: 'Registrati',
    registerTitle: 'Crea un account',
    registerSubtitle: 'Registrati per prenotare le postazioni',
    firstName: 'Nome',
    lastName: 'Cognome',
    phone: 'Telefono',
    firstNamePlaceholder: 'Mario',
    lastNamePlaceholder: 'Rossi',
    phonePlaceholder: '+39 123 456 7890',
    registering: 'Registrazione...',
    alreadyHaveAccount: 'Hai già un account?',
    noAccount: 'Non hai un account?',
    goToLogin: 'Accedi',
    goToRegister: 'Registrati',
    // Roles
    roleAdmin: 'Amministratore',
    roleInterno: 'Interno',
    roleCoworker: 'Coworker',
    interno: 'Interno',
    coworker: 'Coworker',
    // Admin booking for others
    bookOnBehalf: 'Prenota per conto di',
    selectUser: 'Seleziona utente',
    bookingFor: 'Per: {name}',
    // Billing & Registration extended
    personalData: 'Dati anagrafici',
    billingData: 'Dati fatturazione',
    billingSameAsPersonal: 'I dati di fatturazione coincidono con quelli anagrafici',
    ragioneSociale: 'Ragione sociale',
    indirizzo: 'Indirizzo',
    cap: 'CAP',
    citta: 'Città',
    paese: 'Paese',
    partitaIva: 'Partita IVA',
    codiceFiscale: 'Codice Fiscale',
    pecSdi: 'PEC / Codice SDI',
    acceptLpd: 'Ho letto e accetto l\'informativa sulla privacy (LPD)',
    acceptDisclaimer: 'Ho letto e accetto il regolamento per l\'utilizzo degli spazi comuni',
    readLpd: 'Leggi informativa privacy',
    readDisclaimer: 'Leggi regolamento spazi comuni',
    lpdText: 'Il testo dell\'informativa sulla privacy verrà definito prossimamente.',
    disclaimerText: 'Il testo del regolamento per l\'utilizzo degli spazi comuni verrà definito prossimamente.',
    mustAcceptTerms: 'Devi accettare l\'informativa sulla privacy e il regolamento',
    next: 'Avanti',
    back: 'Indietro',
    step: 'Passo',
    // Pricing
    pricing: 'Prezzi',
    pricingManagement: 'Gestione Prezzi',
    deskPricing: 'Prezzi Scrivanie',
    parkingPricing: 'Prezzi Parcheggi',
    dailyPrices: 'Prezzi giornalieri',
    longPeriodPrices: 'Prezzi lungo periodo',
    minDays: 'Da (giorni)',
    maxDays: 'A (giorni)',
    pricePerDay: 'Prezzo/giorno',
    label: 'Etichetta',
    addRule: 'Aggiungi fascia',
    removeRule: 'Rimuovi',
    savePricing: 'Salva prezzi',
    pricingSaved: 'Prezzi salvati con successo',
    unlimited: 'Illimitato',
    // Long period requests
    longPeriodRequest: 'Richiesta lungo periodo',
    longPeriodRequests: 'Richieste Lungo Periodo',
    longPeriodDesc: 'Per prenotazioni superiori a 30 giorni consecutivi',
    longPeriodLink: 'Hai bisogno di un periodo più lungo di 30 giorni?',
    longPeriodClickHere: 'Richiedi qui',
    sendRequest: 'Invia richiesta',
    requestSent: 'Richiesta inviata con successo!',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    notes: 'Note aggiuntive',
    notesPlaceholder: 'Dettagli sulla richiesta...',
    requestStatus: 'Stato',
    pending: 'In attesa',
    approved: 'Approvata',
    rejected: 'Rifiutata',
    adminNotes: 'Note amministratore',
    noRequests: 'Nessuna richiesta',
    myRequests: 'Le mie richieste',
    allRequests: 'Tutte le richieste',
    requestFrom: 'Richiesta di',
    approve: 'Approva',
    reject: 'Rifiuta',
    preferredDesk: 'Scrivania preferita (opzionale)',
    noPreference: 'Nessuna preferenza',
    // Cart
    cart: 'Carrello',
    cartEmpty: 'Il carrello è vuoto',
    cartEmptyDesc: 'Aggiungi scrivanie o parcheggi al carrello per procedere',
    addToCart: 'Aggiungi al carrello',
    addedToCart: 'Aggiunto al carrello!',
    goToCart: 'Vai al carrello',
    removeFromCart: 'Rimuovi',
    checkout: 'Procedi al pagamento',
    cartTotal: 'Totale',
    cartItems: '{count} elementi',
    expiresIn: 'Scade tra',
    hours: 'ore',
    confirmPayment: 'Conferma pagamento',
    paymentConfirmed: 'Pagamento confermato! Prenotazioni confermate.',
    cartExpiry: 'Le prenotazioni scadono in 24h se non pagate',
    goToParking: 'Vuoi anche un parcheggio?',
    continueShopping: 'Continua a prenotare',
    exportDb: 'Esporta Database',
    exporting: 'Esportazione...',
    exportSuccess: 'Database esportato con successo',
    resetPassword: 'Reset Password',
    newPassword: 'Nuova password',
    passwordReset: 'Password aggiornata con successo',
  },

  en: {
    systemName: 'CoWork Desk',
    systemSubtitle: 'Booking System',
    desks: 'Desks',
    meetingRoom: 'Meeting Room',
    parking: 'Parking',
    logout: 'Logout',
    admin: 'Admin',

    welcome: 'Welcome back!',
    loginSubtitle: 'Login to book your desk',
    loginDescription: 'Book your desk quickly and easily',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    contactAdmin: 'Contact the administrator to get your credentials',
    emailPlaceholder: 'name@example.com',
    passwordPlaceholder: 'Your password',

    book: 'Book',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',

    selectPeriod: 'Select period',
    deskMap: 'Desk map',
    myBookings: 'My bookings',
    available: 'Available',
    occupied: 'Occupied',
    yourBooking: 'Yours',
    selected: 'Selected',
    notActive: 'Not active',
    entrance: 'ENTRANCE',
    windows: 'WINDOWS',
    corridor: 'Corridor',
    deskSelected: 'Desk {desk} selected',
    confirmBooking: 'Confirm Booking',
    noBookings: 'You have no bookings yet',
    goToBook: 'Go to "Book" section to book a desk',
    from: 'From',
    to: 'to',
    days: 'days',
    day: 'day',
    selectedPeriodLabel: 'Selected period:',
    clickStartEnd: 'Click a start date, then an end date',
    selectPeriodAndDesk: 'Select a period and a desk',
    deskBookedSuccess: 'Desk {desk} booked successfully!',
    bookingCancelled: 'Booking cancelled',
    yourBookings: 'Your bookings',

    meetingRoomTitle: 'Meeting Room',
    meetingRoomSubtitle: 'Book the meeting room for your meetings',
    calendar: 'Calendar',
    selectDay: 'Select a day',
    clickDay: 'Click on a day to see details',
    free: 'Free',
    partial: 'Partial',
    fullDay: 'Full',
    bookMeetingRoom: 'Book Meeting Room',
    meetingTitle: 'Meeting title',
    meetingTitlePlaceholder: 'E.g. Marketing team meeting',
    startTime: 'Start time',
    endTime: 'End time',
    description: 'Description (optional)',
    descriptionPlaceholder: 'Add meeting details...',
    meetingRoomBooked: 'Meeting room booked!',
    freeSlot: 'Free',
    dayLetters: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
    dayShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],

    parkingTitle: 'Parking',
    parkingSubtitle: 'Book your parking spot',
    selectDate: 'Select date',
    parkingMap: 'Parking Map',
    morning: 'Morning',
    afternoon: 'Afternoon',
    fullDayParking: 'Full day',
    selectPeriodParking: 'Select period:',
    parkingBooked: 'Parking {spot} booked for {period}!',
    yourParkingBookings: 'Your parking bookings',
    noParkingBookings: 'You have no parking bookings',
    commonArea: 'Common area',
    parkingFree: 'Free',
    parkingPartial: 'Partial',
    parkingOccupied: 'Occupied',
    parkingYours: 'Yours',
    parkingNotActive: 'Not active',
    selectDateFirst: 'Select a date first',
    periodNotAvailable: 'This period is not available',
    selectDateAndSpot: 'Select date and parking spot',
    parkingSpotLabel: 'Parking',
    parkingFullDay: 'Full day',

    manageDesks: 'Manage Desks',
    manageParking: 'Manage Parking',
    toggleAvailability: 'Enable or disable desks available for booking',
    toggleParkingAvailability: 'Enable or disable parking spots available for booking',
    active: 'Active',
    disabled: 'Disabled',
    overview: 'Overview',
    users: 'Users',
    bookings: 'Bookings',
    userManagement: 'User Management',
    newUser: 'New User',
    createUser: 'Create User',
    createNewUser: 'Create New User',
    name: 'Name',
    namePlaceholder: 'John Doe',
    adminEmailPlaceholder: 'john@example.com',
    adminPasswordPlaceholder: 'Secure password',
    administrator: 'Administrator',
    user: 'User',
    noUsers: 'No users found',
    allBookings: 'All Bookings',
    noBookingsFound: 'No bookings',
    blockDesk: 'Block Desk {desk}',
    blockDeskBtn: 'Block Desk',
    desk: 'Desk',
    spot: 'Spot',
    past: 'Past',
    showPastBookings: 'Show past bookings',
    filterByDesk: 'Filter by desk',
    allDesks: 'All desks',
    deskBlockedSuccess: 'Desk {desk} blocked for {days} days',
    deskActivated: 'Desk {desk} activated',
    deskDeactivated: 'Desk {desk} deactivated',
    userCreatedSuccess: 'User created successfully',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    userDeleted: 'User deleted',
    parkingActivated: 'Parking {spot} activated',
    parkingDeactivated: 'Parking {spot} deactivated',
    roleAdmin: 'Administrator',
    roleUser: 'User',
    setAsAdmin: 'Set as administrator',
    roleUpdated: 'Role updated',
    cannotChangeOwnRole: 'Cannot change your own role',
    monitor: 'Monitor',
    hasMonitor: 'Monitor',
    withMonitor: 'With monitor',
    withoutMonitor: 'Without monitor',
    availableWeekdays: 'Available days',
    weekdaysUpdated: 'Available days updated for desk {desk}',
    weekdaysMinOne: 'At least one day must remain available',
    verifyEmailTitle: 'Verify your email address',
    verifyEmailDesc: 'We sent an email to {email}. Confirm your address to start booking.',
    resendVerification: 'Resend email',
    verificationEmailSent: 'Verification email sent! Check your inbox.',
    verifyEmailSuccessTitle: 'Email verified!',
    verifyEmailSuccessDesc: 'Your address is confirmed. You can now book desks, the meeting room and parking.',
    verifyEmailErrorTitle: 'Verification failed',
    verifyEmailInvalid: 'Invalid or already used verification link',
    verifyEmailContinue: 'Go to dashboard',
    registerCheckEmail: 'Registration complete! Check your email to confirm your address.',
    confirmationEmailSent: 'We sent you the summary by email',
    register: 'Register',
    registerTitle: 'Create an account',
    registerSubtitle: 'Register to book workstations',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    firstNamePlaceholder: 'John',
    lastNamePlaceholder: 'Doe',
    phonePlaceholder: '+1 234 567 8900',
    registering: 'Registering...',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    goToLogin: 'Login',
    goToRegister: 'Register',
    roleAdmin: 'Administrator',
    roleInterno: 'Internal',
    roleCoworker: 'Coworker',
    interno: 'Internal',
    coworker: 'Coworker',
    bookOnBehalf: 'Book on behalf of',
    selectUser: 'Select user',
    bookingFor: 'For: {name}',
    personalData: 'Personal data',
    billingData: 'Billing data',
    billingSameAsPersonal: 'Billing data same as personal data',
    ragioneSociale: 'Company name',
    indirizzo: 'Address',
    cap: 'Postal code',
    citta: 'City',
    paese: 'Country',
    partitaIva: 'VAT number',
    codiceFiscale: 'Tax code',
    pecSdi: 'PEC / SDI code',
    acceptLpd: 'I have read and accept the privacy policy (LPD)',
    acceptDisclaimer: 'I have read and accept the terms of use for common areas',
    readLpd: 'Read privacy policy',
    readDisclaimer: 'Read terms of use',
    lpdText: 'The privacy policy text will be defined soon.',
    disclaimerText: 'The terms of use for common areas will be defined soon.',
    mustAcceptTerms: 'You must accept the privacy policy and terms of use',
    next: 'Next',
    back: 'Back',
    step: 'Step',
    pricing: 'Pricing',
    pricingManagement: 'Pricing Management',
    deskPricing: 'Desk Pricing',
    parkingPricing: 'Parking Pricing',
    dailyPrices: 'Daily prices',
    longPeriodPrices: 'Long period prices',
    minDays: 'From (days)',
    maxDays: 'To (days)',
    pricePerDay: 'Price/day',
    label: 'Label',
    addRule: 'Add tier',
    removeRule: 'Remove',
    savePricing: 'Save pricing',
    pricingSaved: 'Pricing saved successfully',
    unlimited: 'Unlimited',
    longPeriodRequest: 'Long period request',
    longPeriodRequests: 'Long Period Requests',
    longPeriodDesc: 'For bookings longer than 30 consecutive days',
    longPeriodLink: 'Need a period longer than 30 days?',
    longPeriodClickHere: 'Request here',
    sendRequest: 'Send request',
    requestSent: 'Request sent successfully!',
    startDate: 'Start date',
    endDate: 'End date',
    notes: 'Additional notes',
    notesPlaceholder: 'Details about your request...',
    requestStatus: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    adminNotes: 'Admin notes',
    noRequests: 'No requests',
    myRequests: 'My requests',
    allRequests: 'All requests',
    requestFrom: 'Request from',
    approve: 'Approve',
    reject: 'Reject',
    preferredDesk: 'Preferred desk (optional)',
    noPreference: 'No preference',
    cart: 'Cart',
    cartEmpty: 'Your cart is empty',
    cartEmptyDesc: 'Add desks or parking spots to proceed',
    addToCart: 'Add to cart',
    addedToCart: 'Added to cart!',
    goToCart: 'Go to cart',
    removeFromCart: 'Remove',
    checkout: 'Proceed to payment',
    cartTotal: 'Total',
    cartItems: '{count} items',
    expiresIn: 'Expires in',
    hours: 'hours',
    confirmPayment: 'Confirm payment',
    paymentConfirmed: 'Payment confirmed! Bookings confirmed.',
    cartExpiry: 'Bookings expire in 24h if not paid',
    goToParking: 'Need a parking spot too?',
    continueShopping: 'Continue booking',
    exportDb: 'Export Database',
    exporting: 'Exporting...',
    exportSuccess: 'Database exported successfully',
    resetPassword: 'Reset Password',
    newPassword: 'New password',
    passwordReset: 'Password updated successfully',
  },

  fr: {
    systemName: 'CoWork Desk',
    systemSubtitle: 'Systeme de Reservation',
    desks: 'Bureaux',
    meetingRoom: 'Salle de Reunion',
    parking: 'Parking',
    logout: 'Deconnexion',
    admin: 'Admin',

    welcome: 'Bienvenue!',
    loginSubtitle: 'Connectez-vous pour reserver votre bureau',
    loginDescription: 'Reservez votre bureau simplement et rapidement',
    email: 'Email',
    password: 'Mot de passe',
    login: 'Connexion',
    loggingIn: 'Connexion en cours...',
    contactAdmin: "Contactez l'administrateur pour obtenir vos identifiants",
    emailPlaceholder: 'nom@exemple.com',
    passwordPlaceholder: 'Votre mot de passe',

    book: 'Reserver',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    save: 'Enregistrer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succes',

    selectPeriod: 'Selectionner la periode',
    deskMap: 'Plan des bureaux',
    myBookings: 'Mes reservations',
    available: 'Disponible',
    occupied: 'Occupe',
    yourBooking: 'Votre',
    selected: 'Selectionne',
    notActive: 'Inactif',
    entrance: 'ENTREE',
    windows: 'FENETRES',
    corridor: 'Couloir',
    deskSelected: 'Bureau {desk} selectionne',
    confirmBooking: 'Confirmer la Reservation',
    noBookings: "Vous n'avez pas encore de reservations",
    goToBook: 'Allez a "Reserver" pour reserver un bureau',
    from: 'Du',
    to: 'au',
    days: 'jours',
    day: 'jour',
    selectedPeriodLabel: 'Periode selectionnee:',
    clickStartEnd: 'Cliquez sur une date de debut, puis sur la date de fin',
    selectPeriodAndDesk: 'Selectionnez une periode et un bureau',
    deskBookedSuccess: 'Bureau {desk} reserve avec succes!',
    bookingCancelled: 'Reservation annulee',
    yourBookings: 'Vos reservations',

    meetingRoomTitle: 'Salle de Reunion',
    meetingRoomSubtitle: 'Reservez la salle de reunion',
    calendar: 'Calendrier',
    selectDay: 'Selectionner un jour',
    clickDay: 'Cliquez sur un jour pour voir les details',
    free: 'Libre',
    partial: 'Partiel',
    fullDay: 'Complet',
    bookMeetingRoom: 'Reserver Salle de Reunion',
    meetingTitle: 'Titre de la reunion',
    meetingTitlePlaceholder: 'Ex. Reunion equipe marketing',
    startTime: 'Heure de debut',
    endTime: 'Heure de fin',
    description: 'Description (optionnel)',
    descriptionPlaceholder: 'Ajouter des details...',
    meetingRoomBooked: 'Salle de reunion reservee!',
    freeSlot: 'Libre',
    dayLetters: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
    dayShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],

    parkingTitle: 'Parking',
    parkingSubtitle: 'Reservez votre place de parking',
    selectDate: 'Selectionner la date',
    parkingMap: 'Plan du Parking',
    morning: 'Matin',
    afternoon: 'Apres-midi',
    fullDayParking: 'Journee',
    selectPeriodParking: 'Selectionner la periode:',
    parkingBooked: 'Parking {spot} reserve pour {period}!',
    yourParkingBookings: 'Vos reservations parking',
    noParkingBookings: "Vous n'avez pas de reservations parking",
    commonArea: 'Zone commune',
    parkingFree: 'Libre',
    parkingPartial: 'Partiel',
    parkingOccupied: 'Occupe',
    parkingYours: 'Votre',
    parkingNotActive: 'Inactif',
    selectDateFirst: "Selectionnez d'abord une date",
    periodNotAvailable: "Cette periode n'est pas disponible",
    selectDateAndSpot: 'Selectionnez la date et la place',
    parkingSpotLabel: 'Parking',
    parkingFullDay: 'Journee entiere',

    manageDesks: 'Gestion des Bureaux',
    manageParking: 'Gestion du Parking',
    toggleAvailability: 'Activer ou desactiver les bureaux disponibles',
    toggleParkingAvailability: 'Activer ou desactiver les places de parking',
    active: 'Actif',
    disabled: 'Desactive',
    overview: 'Apercu',
    users: 'Utilisateurs',
    bookings: 'Reservations',
    userManagement: 'Gestion des Utilisateurs',
    newUser: 'Nouvel Utilisateur',
    createUser: 'Creer Utilisateur',
    createNewUser: 'Creer Nouvel Utilisateur',
    name: 'Nom',
    namePlaceholder: 'Jean Dupont',
    adminEmailPlaceholder: 'jean@exemple.com',
    adminPasswordPlaceholder: 'Mot de passe securise',
    administrator: 'Administrateur',
    user: 'Utilisateur',
    noUsers: 'Aucun utilisateur trouve',
    allBookings: 'Toutes les Reservations',
    noBookingsFound: 'Aucune reservation',
    blockDesk: 'Bloquer Bureau {desk}',
    blockDeskBtn: 'Bloquer Bureau',
    desk: 'Bureau',
    spot: 'Place',
    past: 'Passee',
    showPastBookings: 'Afficher les reservations passees',
    filterByDesk: 'Filtrer par bureau',
    allDesks: 'Tous les bureaux',
    deskBlockedSuccess: 'Bureau {desk} bloque pour {days} jours',
    deskActivated: 'Bureau {desk} active',
    deskDeactivated: 'Bureau {desk} desactive',
    userCreatedSuccess: 'Utilisateur cree avec succes',
    confirmDeleteUser: 'Etes-vous sur de vouloir supprimer cet utilisateur?',
    userDeleted: 'Utilisateur supprime',
    parkingActivated: 'Parking {spot} active',
    parkingDeactivated: 'Parking {spot} desactive',
    roleAdmin: 'Administrateur',
    roleUser: 'Utilisateur',
    setAsAdmin: 'Definir comme administrateur',
    roleUpdated: 'Role mis a jour',
    cannotChangeOwnRole: 'Vous ne pouvez pas changer votre propre role',
    monitor: 'Moniteur',
    hasMonitor: 'Moniteur',
    withMonitor: 'Avec moniteur',
    withoutMonitor: 'Sans moniteur',
    availableWeekdays: 'Jours disponibles',
    weekdaysUpdated: 'Jours disponibles mis a jour pour le bureau {desk}',
    weekdaysMinOne: 'Au moins un jour doit rester disponible',
    verifyEmailTitle: 'Verifiez votre adresse email',
    verifyEmailDesc: 'Nous avons envoye un email a {email}. Confirmez votre adresse pour reserver.',
    resendVerification: 'Renvoyer l\'email',
    verificationEmailSent: 'Email de verification envoye! Consultez votre boite.',
    verifyEmailSuccessTitle: 'Email verifie!',
    verifyEmailSuccessDesc: 'Votre adresse est confirmee. Vous pouvez desormais reserver.',
    verifyEmailErrorTitle: 'Verification echouee',
    verifyEmailInvalid: 'Lien de verification invalide ou deja utilise',
    verifyEmailContinue: 'Aller au tableau de bord',
    registerCheckEmail: 'Inscription terminee! Consultez votre email pour confirmer votre adresse.',
    confirmationEmailSent: 'Nous vous avons envoye le recapitulatif par email',
    register: "S'inscrire",
    registerTitle: 'Creer un compte',
    registerSubtitle: 'Inscrivez-vous pour reserver des postes',
    firstName: 'Prenom',
    lastName: 'Nom',
    phone: 'Telephone',
    firstNamePlaceholder: 'Jean',
    lastNamePlaceholder: 'Dupont',
    phonePlaceholder: '+33 1 23 45 67 89',
    registering: 'Inscription...',
    alreadyHaveAccount: 'Vous avez deja un compte?',
    noAccount: "Vous n'avez pas de compte?",
    goToLogin: 'Connexion',
    goToRegister: "S'inscrire",
    roleAdmin: 'Administrateur',
    roleInterno: 'Interne',
    roleCoworker: 'Coworker',
    interno: 'Interne',
    coworker: 'Coworker',
    bookOnBehalf: 'Reserver pour le compte de',
    selectUser: 'Selectionner un utilisateur',
    bookingFor: 'Pour: {name}',
    personalData: 'Donnees personnelles',
    billingData: 'Donnees de facturation',
    billingSameAsPersonal: 'Les donnees de facturation sont identiques aux donnees personnelles',
    ragioneSociale: 'Raison sociale',
    indirizzo: 'Adresse',
    cap: 'Code postal',
    citta: 'Ville',
    paese: 'Pays',
    partitaIva: 'Numero TVA',
    codiceFiscale: 'Code fiscal',
    pecSdi: 'PEC / Code SDI',
    acceptLpd: "J'ai lu et j'accepte la politique de confidentialite",
    acceptDisclaimer: "J'ai lu et j'accepte le reglement des espaces communs",
    mustAcceptTerms: 'Vous devez accepter la politique de confidentialite et le reglement',
    next: 'Suivant',
    back: 'Retour',
    step: 'Etape',
    pricing: 'Tarifs',
    pricingManagement: 'Gestion des tarifs',
    deskPricing: 'Tarifs Bureaux',
    parkingPricing: 'Tarifs Parking',
    dailyPrices: 'Tarifs journaliers',
    longPeriodPrices: 'Tarifs longue duree',
    minDays: 'De (jours)',
    maxDays: 'A (jours)',
    pricePerDay: 'Prix/jour',
    label: 'Libelle',
    addRule: 'Ajouter un palier',
    removeRule: 'Supprimer',
    savePricing: 'Enregistrer les tarifs',
    pricingSaved: 'Tarifs enregistres avec succes',
    unlimited: 'Illimite',
    longPeriodRequest: 'Demande longue duree',
    longPeriodRequests: 'Demandes Longue Duree',
    longPeriodDesc: 'Pour les reservations de plus de 30 jours consecutifs',
    longPeriodLink: 'Besoin d\'une periode de plus de 30 jours?',
    longPeriodClickHere: 'Demander ici',
    sendRequest: 'Envoyer la demande',
    requestSent: 'Demande envoyee avec succes!',
    startDate: 'Date de debut',
    endDate: 'Date de fin',
    notes: 'Notes supplementaires',
    notesPlaceholder: 'Details de votre demande...',
    requestStatus: 'Statut',
    pending: 'En attente',
    approved: 'Approuvee',
    rejected: 'Refusee',
    adminNotes: 'Notes administrateur',
    noRequests: 'Aucune demande',
    myRequests: 'Mes demandes',
    allRequests: 'Toutes les demandes',
    requestFrom: 'Demande de',
    approve: 'Approuver',
    reject: 'Refuser',
    preferredDesk: 'Bureau prefere (optionnel)',
    noPreference: 'Aucune preference',
    cart: 'Panier',
    cartEmpty: 'Votre panier est vide',
    cartEmptyDesc: 'Ajoutez des bureaux ou des places de parking',
    addToCart: 'Ajouter au panier',
    addedToCart: 'Ajoute au panier!',
    goToCart: 'Voir le panier',
    removeFromCart: 'Supprimer',
    checkout: 'Passer au paiement',
    cartTotal: 'Total',
    cartItems: '{count} articles',
    expiresIn: 'Expire dans',
    hours: 'heures',
    confirmPayment: 'Confirmer le paiement',
    paymentConfirmed: 'Paiement confirme! Reservations confirmees.',
    cartExpiry: 'Les reservations expirent en 24h si non payees',
    goToParking: 'Besoin d\'une place de parking?',
    continueShopping: 'Continuer a reserver',
    exportDb: 'Exporter la base de donnees',
    exporting: 'Exportation...',
    exportSuccess: 'Base de donnees exportee avec succes',
    resetPassword: 'Reinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    passwordReset: 'Mot de passe mis a jour',
  },

  de: {
    systemName: 'CoWork Desk',
    desks: 'Schreibtische',
    meetingRoom: 'Besprechungsraum',
    parking: 'Parkplatz',
    logout: 'Abmelden',
    admin: 'Admin',

    welcome: 'Willkommen zuruck!',
    loginSubtitle: 'Melden Sie sich an, um Ihren Schreibtisch zu buchen',
    loginDescription: 'Buchen Sie Ihren Schreibtisch schnell und einfach',
    email: 'E-Mail',
    password: 'Passwort',
    login: 'Anmelden',
    loggingIn: 'Anmeldung lauft...',
    contactAdmin: 'Kontaktieren Sie den Administrator fur Ihre Zugangsdaten',
    emailPlaceholder: 'name@beispiel.de',
    passwordPlaceholder: 'Ihr Passwort',

    book: 'Buchen',
    confirm: 'Bestatigen',
    cancel: 'Abbrechen',
    delete: 'Loschen',
    save: 'Speichern',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',

    selectPeriod: 'Zeitraum auswahlen',
    deskMap: 'Schreibtisch-Karte',
    myBookings: 'Meine Buchungen',
    available: 'Verfugbar',
    occupied: 'Belegt',
    yourBooking: 'Ihre',
    selected: 'Ausgewahlt',
    notActive: 'Nicht aktiv',
    entrance: 'EINGANG',
    windows: 'FENSTER',
    corridor: 'Flur',
    deskSelected: 'Schreibtisch {desk} ausgewahlt',
    confirmBooking: 'Buchung Bestatigen',
    noBookings: 'Sie haben noch keine Buchungen',
    goToBook: 'Gehen Sie zu "Buchen" um einen Schreibtisch zu buchen',
    from: 'Vom',
    to: 'bis',
    days: 'Tage',
    day: 'Tag',
    selectedPeriodLabel: 'Ausgewahlter Zeitraum:',
    clickStartEnd: 'Klicken Sie auf ein Startdatum, dann auf ein Enddatum',
    selectPeriodAndDesk: 'Wahlen Sie einen Zeitraum und einen Schreibtisch',
    deskBookedSuccess: 'Schreibtisch {desk} erfolgreich gebucht!',
    bookingCancelled: 'Buchung storniert',
    yourBookings: 'Ihre Buchungen',

    meetingRoomTitle: 'Besprechungsraum',
    meetingRoomSubtitle: 'Buchen Sie den Besprechungsraum',
    calendar: 'Kalender',
    selectDay: 'Tag auswahlen',
    clickDay: 'Klicken Sie auf einen Tag fur Details',
    free: 'Frei',
    partial: 'Teilweise',
    fullDay: 'Voll',
    bookMeetingRoom: 'Besprechungsraum Buchen',
    meetingTitle: 'Besprechungstitel',
    meetingTitlePlaceholder: 'Z.B. Marketing-Team Meeting',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    description: 'Beschreibung (optional)',
    descriptionPlaceholder: 'Details hinzufugen...',
    meetingRoomBooked: 'Besprechungsraum gebucht!',
    freeSlot: 'Frei',
    dayLetters: ['M', 'D', 'M', 'D', 'F', 'S', 'S'],
    dayShort: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],

    parkingTitle: 'Parkplatz',
    parkingSubtitle: 'Buchen Sie Ihren Parkplatz',
    selectDate: 'Datum auswahlen',
    parkingMap: 'Parkplatz-Karte',
    morning: 'Vormittag',
    afternoon: 'Nachmittag',
    fullDayParking: 'Ganztags',
    selectPeriodParking: 'Zeitraum auswahlen:',
    parkingBooked: 'Parkplatz {spot} fur {period} gebucht!',
    yourParkingBookings: 'Ihre Parkplatz-Buchungen',
    noParkingBookings: 'Sie haben keine Parkplatz-Buchungen',
    commonArea: 'Gemeinschaftsbereich',
    parkingFree: 'Frei',
    parkingPartial: 'Teilweise',
    parkingOccupied: 'Belegt',
    parkingYours: 'Ihres',
    parkingNotActive: 'Nicht aktiv',
    selectDateFirst: 'Wahlen Sie zuerst ein Datum',
    periodNotAvailable: 'Dieser Zeitraum ist nicht verfugbar',
    selectDateAndSpot: 'Wahlen Sie Datum und Parkplatz',
    parkingSpotLabel: 'Parkplatz',
    parkingFullDay: 'Ganztags',

    manageDesks: 'Schreibtische Verwalten',
    manageParking: 'Parkplatze Verwalten',
    toggleAvailability: 'Verfugbare Schreibtische aktivieren oder deaktivieren',
    toggleParkingAvailability: 'Verfugbare Parkplatze aktivieren oder deaktivieren',
    active: 'Aktiv',
    disabled: 'Deaktiviert',
    overview: 'Ubersicht',
    users: 'Benutzer',
    bookings: 'Buchungen',
    userManagement: 'Benutzerverwaltung',
    newUser: 'Neuer Benutzer',
    createUser: 'Benutzer Erstellen',
    createNewUser: 'Neuen Benutzer Erstellen',
    name: 'Name',
    namePlaceholder: 'Max Mustermann',
    adminEmailPlaceholder: 'max@beispiel.de',
    adminPasswordPlaceholder: 'Sicheres Passwort',
    administrator: 'Administrator',
    user: 'Benutzer',
    noUsers: 'Keine Benutzer gefunden',
    allBookings: 'Alle Buchungen',
    noBookingsFound: 'Keine Buchungen',
    blockDesk: 'Schreibtisch {desk} Blockieren',
    blockDeskBtn: 'Schreibtisch Blockieren',
    desk: 'Schreibtisch',
    spot: 'Platz',
    past: 'Vergangen',
    showPastBookings: 'Vergangene Buchungen anzeigen',
    filterByDesk: 'Nach Schreibtisch filtern',
    allDesks: 'Alle Schreibtische',
    deskBlockedSuccess: 'Schreibtisch {desk} fur {days} Tage blockiert',
    deskActivated: 'Schreibtisch {desk} aktiviert',
    deskDeactivated: 'Schreibtisch {desk} deaktiviert',
    userCreatedSuccess: 'Benutzer erfolgreich erstellt',
    confirmDeleteUser: 'Sind Sie sicher, dass Sie diesen Benutzer loschen mochten?',
    userDeleted: 'Benutzer geloscht',
    parkingActivated: 'Parkplatz {spot} aktiviert',
    parkingDeactivated: 'Parkplatz {spot} deaktiviert',
    roleAdmin: 'Administrator',
    roleUser: 'Benutzer',
    setAsAdmin: 'Als Administrator festlegen',
    roleUpdated: 'Rolle aktualisiert',
    cannotChangeOwnRole: 'Sie konnen Ihre eigene Rolle nicht andern',
    monitor: 'Monitor',
    hasMonitor: 'Monitor',
    withMonitor: 'Mit Monitor',
    withoutMonitor: 'Ohne Monitor',
    availableWeekdays: 'Verfugbare Tage',
    weekdaysUpdated: 'Verfugbare Tage fur Schreibtisch {desk} aktualisiert',
    weekdaysMinOne: 'Mindestens ein Tag muss verfugbar bleiben',
    verifyEmailTitle: 'Bestatigen Sie Ihre E-Mail-Adresse',
    verifyEmailDesc: 'Wir haben eine E-Mail an {email} gesendet. Bestatigen Sie Ihre Adresse, um zu buchen.',
    resendVerification: 'E-Mail erneut senden',
    verificationEmailSent: 'Bestatigungs-E-Mail gesendet! Prufen Sie Ihr Postfach.',
    verifyEmailSuccessTitle: 'E-Mail bestatigt!',
    verifyEmailSuccessDesc: 'Ihre Adresse ist bestatigt. Sie konnen jetzt buchen.',
    verifyEmailErrorTitle: 'Bestatigung fehlgeschlagen',
    verifyEmailInvalid: 'Ungultiger oder bereits verwendeter Bestatigungslink',
    verifyEmailContinue: 'Zum Dashboard',
    registerCheckEmail: 'Registrierung abgeschlossen! Prufen Sie Ihre E-Mail zur Bestatigung.',
    confirmationEmailSent: 'Wir haben Ihnen die Zusammenfassung per E-Mail gesendet',
    register: 'Registrieren',
    registerTitle: 'Konto erstellen',
    registerSubtitle: 'Registrieren Sie sich, um Arbeitsplatze zu buchen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    firstNamePlaceholder: 'Max',
    lastNamePlaceholder: 'Mustermann',
    phonePlaceholder: '+49 123 456 7890',
    registering: 'Registrierung...',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    noAccount: 'Haben Sie kein Konto?',
    goToLogin: 'Anmelden',
    goToRegister: 'Registrieren',
    roleAdmin: 'Administrator',
    roleInterno: 'Intern',
    roleCoworker: 'Coworker',
    interno: 'Intern',
    coworker: 'Coworker',
    bookOnBehalf: 'Buchen im Auftrag von',
    selectUser: 'Benutzer auswahlen',
    bookingFor: 'Fur: {name}',
    personalData: 'Personliche Daten',
    billingData: 'Rechnungsdaten',
    billingSameAsPersonal: 'Rechnungsdaten entsprechen den personlichen Daten',
    ragioneSociale: 'Firmenname',
    indirizzo: 'Adresse',
    cap: 'PLZ',
    citta: 'Stadt',
    paese: 'Land',
    partitaIva: 'USt-IdNr.',
    codiceFiscale: 'Steuernummer',
    pecSdi: 'PEC / SDI-Code',
    acceptLpd: 'Ich habe die Datenschutzerklarung gelesen und akzeptiere sie',
    acceptDisclaimer: 'Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie',
    mustAcceptTerms: 'Sie mussen die Datenschutzerklarung und die Nutzungsbedingungen akzeptieren',
    next: 'Weiter',
    back: 'Zuruck',
    step: 'Schritt',
    pricing: 'Preise',
    pricingManagement: 'Preisverwaltung',
    deskPricing: 'Schreibtisch-Preise',
    parkingPricing: 'Parkplatz-Preise',
    dailyPrices: 'Tagespreise',
    longPeriodPrices: 'Langzeitpreise',
    minDays: 'Von (Tage)',
    maxDays: 'Bis (Tage)',
    pricePerDay: 'Preis/Tag',
    label: 'Bezeichnung',
    addRule: 'Stufe hinzufugen',
    removeRule: 'Entfernen',
    savePricing: 'Preise speichern',
    pricingSaved: 'Preise erfolgreich gespeichert',
    unlimited: 'Unbegrenzt',
    longPeriodRequest: 'Langzeitanfrage',
    longPeriodRequests: 'Langzeitanfragen',
    longPeriodDesc: 'Fur Buchungen von mehr als 30 aufeinanderfolgenden Tagen',
    longPeriodLink: 'Benotigen Sie einen Zeitraum von mehr als 30 Tagen?',
    longPeriodClickHere: 'Hier anfragen',
    sendRequest: 'Anfrage senden',
    requestSent: 'Anfrage erfolgreich gesendet!',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    notes: 'Zusatzliche Anmerkungen',
    notesPlaceholder: 'Details zu Ihrer Anfrage...',
    requestStatus: 'Status',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    adminNotes: 'Admin-Notizen',
    noRequests: 'Keine Anfragen',
    myRequests: 'Meine Anfragen',
    allRequests: 'Alle Anfragen',
    requestFrom: 'Anfrage von',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    preferredDesk: 'Bevorzugter Schreibtisch (optional)',
    noPreference: 'Keine Praferenz',
    cart: 'Warenkorb',
    cartEmpty: 'Ihr Warenkorb ist leer',
    cartEmptyDesc: 'Fugen Sie Schreibtische oder Parkplatze hinzu',
    addToCart: 'In den Warenkorb',
    addedToCart: 'Zum Warenkorb hinzugefugt!',
    goToCart: 'Zum Warenkorb',
    removeFromCart: 'Entfernen',
    checkout: 'Zur Zahlung',
    cartTotal: 'Gesamt',
    cartItems: '{count} Artikel',
    expiresIn: 'Lauft ab in',
    hours: 'Stunden',
    confirmPayment: 'Zahlung bestatigen',
    paymentConfirmed: 'Zahlung bestatigt! Buchungen bestatigt.',
    cartExpiry: 'Buchungen verfallen in 24h ohne Zahlung',
    goToParking: 'Benotigen Sie auch einen Parkplatz?',
    continueShopping: 'Weiter buchen',
    exportDb: 'Datenbank exportieren',
    exporting: 'Exportiere...',
    exportSuccess: 'Datenbank erfolgreich exportiert',
    resetPassword: 'Passwort zurucksetzen',
    newPassword: 'Neues Passwort',
    passwordReset: 'Passwort erfolgreich aktualisiert',
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('cowork_language');
    return saved || 'it';
  });

  useEffect(() => {
    localStorage.setItem('cowork_language', language);
  }, [language]);

  const t = (key, params = {}) => {
    let text = translations[language]?.[key] || translations['it'][key] || key;

    if (typeof text === 'string') {
      Object.keys(params).forEach(param => {
        text = text.replace(`{${param}}`, params[param]);
      });
    }

    return text;
  };

  const dateLocale = dateLocales[language] || dateLocales['it'];

  const value = {
    language,
    setLanguage,
    t,
    dateLocale,
    languages: [
      { code: 'it', name: 'IT' },
      { code: 'en', name: 'EN' },
      { code: 'fr', name: 'FR' },
      { code: 'de', name: 'DE' },
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
